import { roundToDecimals, sumAmounts } from "../../../../lib/money";

/**
 * Sums the top-level Advance line items (Vehicle Advance, CAPS Advantage,
 * Vehicle Service Contract, GAP, ...). Sub-items (e.g. VSC Net Dealer Cost /
 * VSC Profit) are a breakdown of their parent's amount, not additional
 * amounts, so only top-level amounts are summed here.
 * @param {{ amount: number }[]} items - The Advance line items.
 * @returns {number} The total Advance amount.
 */
export function calculateAdvanceTotal(items: Array<{ amount: number }>): number {
  return sumAmounts(items);
}

/**
 * Folds the deduction line items (Deal Fees, VSC/GAP Net Dealer Cost) into
 * the Advance total. Each deduction's `amount` is already negative (it
 * conceptually subtracts), so a future item in this same group with a
 * positive amount (e.g. a rebate/credit) would correctly add instead — the
 * operation lives in the data, not hardcoded here.
 * @param {number} advanceTotal - See calculateAdvanceTotal.
 * @param {{ amount: number }[]} deductions - The deduction line items.
 * @returns {number} The Amount Paid to Dealer Today.
 */
export function calculateAmountPaidToDealerToday(advanceTotal: number, deductions: Array<{ amount: number }>): number {
  return roundToDecimals(advanceTotal + sumAmounts(deductions));
}

/**
 * The gap between what was expected at submit and what was actually paid.
 * @param {number} amountExpectedAtSubmit - The amount expected at submission time.
 * @param {number} amountPaidToDealerToday - See calculateAmountPaidToDealerToday.
 * @returns {number} The difference (can be negative).
 */
export function calculateDifferenceInAmountPaid(
  amountExpectedAtSubmit: number,
  amountPaidToDealerToday: number
): number {
  return roundToDecimals(amountExpectedAtSubmit - amountPaidToDealerToday);
}
